import React from "react";
import { Clock } from "lucide-react";
import { useLang } from "../i18n";
import { HOURS, DAY_INDEX_TO_KEY } from "../data";
import { useSettings } from "../SiteSettings";
import Reveal from "./Reveal";
import OliveBranch from "./OliveBranch";

export const OpeningHours = () => {
  const { t } = useLang();
  const settings = useSettings();
  const hours = Array.isArray(settings.hours) && settings.hours.length ? settings.hours : HOURS;
  const todayKey = DAY_INDEX_TO_KEY[new Date().getDay()];

  return (
    <section
      id="hours"
      className="relative py-24 md:py-32 px-5 md:px-10 bg-black text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_20%_30%,#C5A059_0%,transparent_40%),radial-gradient(circle_at_80%_70%,#8B2635_0%,transparent_40%)]" />
      <div className="max-w-4xl mx-auto relative">
        <Reveal className="text-center flex flex-col items-center mb-12">
          <Clock className="text-qs-gold mb-4" size={30} strokeWidth={1.3} />
          <p className="font-outfit text-qs-gold tracking-[0.3em] uppercase text-xs mb-3">
            {t.hours.eyebrow}
          </p>
          <h2 className="font-cormorant text-3xl sm:text-4xl lg:text-5xl">
            {t.hours.title}
          </h2>
          <OliveBranch className="w-24 text-qs-gold my-5" />
        </Reveal>

        <Reveal delay={100}>
          <div className="divide-y divide-white/10 border-y border-white/10">
            {hours.map((d) => {
              const isToday = d.key === todayKey;
              return (
                <div
                  key={d.key}
                  data-testid={`hours-${d.key}`}
                  className={`flex items-center justify-between py-4 px-4 transition-colors ${
                    isToday ? "bg-qs-red/30" : ""
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <span className="font-cormorant text-xl md:text-2xl">
                      {t.hours.days[d.key]}
                    </span>
                    {isToday && (
                      <span className="text-[10px] font-outfit tracking-widest uppercase bg-qs-gold text-black px-2 py-0.5 rounded-full">
                        {t.hours.today}
                      </span>
                    )}
                  </div>
                  <div className="text-right font-outfit">
                    {d.closed ? (
                      <span className="text-white/50 italic">{t.hours.closed}</span>
                    ) : (
                      <div className="flex flex-col sm:flex-row sm:gap-3 text-sm md:text-base text-white/90">
                        {d.slots.map((slot, i) => (
                          <span key={i} className="tabular-nums tracking-wide">
                            {slot}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <p className="font-outfit text-white/60 text-sm text-center mt-8 max-w-xl mx-auto">
            {t.hours.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default OpeningHours;
